/**
 * 사원 계정의 사원판매 비대상 상품 장바구니 담기 차단
 *
 * 조건: sessionStorage.discount_type === 'emp_sl_uprc'
 *       && product.metafields.custom.employee_target_display === false
 *
 * [data-atc-btn] 클릭을 capture phase로 가로채 팝업 표시 및 open-cart-modal 차단.
 * product-form.js onSubmitHandler 에서도 EmployeeTargetCheck.check() 로 동일 검사.
 */
(function () {
  var popupEl = null;

  function isEmployee() {
    return sessionStorage.getItem('discount_type') === 'emp_sl_uprc';
  }

  function isBlockedTarget(value) {
    return value === 'false' || value === false;
  }

  function ensurePopup() {
    if (popupEl) return;

    var style = document.createElement('style');
    style.textContent =
      '.employee-block-popup{position:fixed;top:0;left:0;width:100%;height:100%;z-index:99999;display:flex;align-items:center;justify-content:center;opacity:0;visibility:hidden;transition:opacity .3s,visibility .3s}' +
      '.employee-block-popup--active{opacity:1;visibility:visible}' +
      '.employee-block-popup__overlay{position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.5);cursor:pointer}' +
      '.employee-block-popup__dialog{position:relative;background:#fff;padding:40px 32px 32px;max-width:400px;width:85%;border-radius:8px;box-shadow:0 4px 20px rgba(0,0,0,.15);z-index:1;text-align:center}' +
      '.employee-block-popup__title{font-size:1.8rem;font-weight:700;margin:0 0 16px;color:#000;line-height:1.3}' +
      '.employee-block-popup__body{font-size:1.4rem;color:#333;margin:0 0 28px;line-height:1.6}' +
      '.employee-block-popup__actions{display:flex;gap:12px;justify-content:center}' +
      '.employee-block-popup__btn{flex:1;max-width:140px;padding:12px 0;border-radius:50px;font-size:1.4rem;font-weight:500;cursor:pointer;transition:opacity .3s;background:#000;color:#fff;border:none}' +
      '.employee-block-popup__btn:hover{opacity:.8}';
    document.head.appendChild(style);

    popupEl = document.createElement('div');
    popupEl.className = 'employee-block-popup';
    popupEl.innerHTML =
      '<div class="employee-block-popup__overlay" data-employee-popup-close></div>' +
      '<div class="employee-block-popup__dialog" role="dialog" aria-modal="true">' +
        '<h2 class="employee-block-popup__title">사원 구매 제한 안내</h2>' +
        '<p class="employee-block-popup__body">해당 상품은 사원판매가 불가능한 상품입니다.</p>' +
        '<div class="employee-block-popup__actions">' +
          '<button type="button" class="employee-block-popup__btn" data-employee-popup-close>확인</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(popupEl);

    popupEl.querySelectorAll('[data-employee-popup-close]').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popupEl && popupEl.classList.contains('employee-block-popup--active')) {
        closePopup();
      }
    });
  }

  function openPopup() {
    ensurePopup();
    popupEl.classList.add('employee-block-popup--active');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    if (!popupEl) return;
    popupEl.classList.remove('employee-block-popup--active');
    document.body.style.overflow = '';
  }

  // PDP ATC 버튼(메인 + 드로어 hidden) 캡처 단계 인터셉트 — open-cart-modal 디스패치 차단
  // button 요소만 매치 — 래퍼 요소까지 올라가 오탐지하는 걸 방지
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[data-employee-target-display]');
    if (!btn) return;
    if (!isEmployee()) return;
    if (!isBlockedTarget(btn.dataset.employeeTargetDisplay)) return;

    if (btn.hasAttribute('data-no-variant-selected')) return;
    if (btn.hasAttribute('disabled')) return;
    if (btn.getAttribute('aria-disabled') === 'true') return;

    e.stopImmediatePropagation();
    e.preventDefault();
    openPopup();
  }, true);

  // product-form.js onSubmitHandler 등 외부에서 호출
  window.EmployeeTargetCheck = {
    check: function (employeeTargetDisplay) {
      if (!isEmployee()) return false;
      if (!isBlockedTarget(employeeTargetDisplay)) return false;
      openPopup();
      return true;
    }
  };
})();
